// ═══════════════════════════════════════════════════════════════
//  通关进度（选关系统的单一数据来源）
//
//  名词定义：
//    「通关一层」= 清空该层全部敌人（门解锁的那一刻）。
//    进度是单调递增的：清空第 N 层后，1..N 层都视为「已通关」。
// ═══════════════════════════════════════════════════════════════
import { CLEARED_FLOOR_KEY, HIGH_FLOOR_KEY, loadNumber, saveNumber } from './storage';

/**
 * 已通关的最高楼层（0 = 尚未通关任何层）。
 *
 * 除已记录的进度外，还从「最高层」纪录推导下限：
 * 能到达第 N 层，必然已经通关了第 1..N-1 层（门必须清空敌人才能通过），
 * 因此对已有存档的老玩家，选关也能立即用上（不必从第 1 层重新刷一遍）。
 */
export function clearedFloor(): number {
  const recorded = loadNumber(CLEARED_FLOOR_KEY);
  const implied = Math.max(0, loadNumber(HIGH_FLOOR_KEY) - 1);
  return Math.max(recorded, implied);
}

/** 可以在选关界面进入的最高楼层（至少第 1 层，等于「从头开始」） */
export function maxSelectableFloor(): number {
  return Math.max(1, clearedFloor());
}

/** 标记某层已通关（只在刷新纪录时写入，避免无谓的 localStorage 写入） */
export function markFloorCleared(floor: number): boolean {
  const f = Math.floor(floor);
  if (!Number.isFinite(f) || f <= clearedFloor()) return false;
  saveNumber(CLEARED_FLOOR_KEY, f);
  return true;
}

/**
 * 把请求的起始楼层夹取到合法范围（1 .. 已通关最高层）。
 * 既用于「选关」入口，也顺带防止通过 console 直接跳到未通关的层。
 */
export function clampStartFloor(floor: number): number {
  const f = Math.floor(floor);
  if (!Number.isFinite(f)) return 1;
  return Math.min(Math.max(1, f), maxSelectableFloor());
}
